import { render, staticRenderFns } from "./CustomerFormDocuments.vue?vue&type=template&id=5ff25c20"
import script from "./CustomerFormDocuments.vue?vue&type=script&lang=ts"
export * from "./CustomerFormDocuments.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports